module.exports = __webpack_public_path__ + "static/gallery_14-thumb-cd896676081d0443acd7d8617157486c.jpg";